<template>
  <a-modal
    :title="title"
    :width="800"
    :visible="visible"
    @ok="pictureSure"
    @cancel="close"
    cancelText="关闭">

    <a-form-item label="单图片上传" :labelCol="labelCol" :wrapperCol="wrapperCol">
      <el-upload
        list-type="picture"
        class="upload-demo"
        :show-file-list="true"
        :action="uploadAction"
        :data="{'isup':1}"
        :headers="headers"
        :before-Upload="beforeUpload"
        drag
        :on-change="handleChange"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将图片拖到此处，或<em>点击上传</em></div>
      </el-upload>
    </a-form-item>
  </a-modal>
</template>
<script>

  export default {
    name: "eleSingleImageSimple",
    props: {
      uploadParam: {
        type: Object,
      }
    },
    data() {
      return {
        title: '单图片组件编辑',
        urlList: [],
        imageUrl: '',
        model: {},
        headers: {},
        formLabelWidth: '120px',
        visible: false,
        conKey: '',
        componentFlag: '',
        labelCol: {
          xs: {span: 24},
          sm: {span: 5},
        },
        wrapperCol: {
          xs: {span: 24},
          sm: {span: 16},
        },
      }
    },
    computed: {
      uploadAction: function () {
        return this.uploadParam.fileUpload;
      }
    },
    created() {
      this.headers = {"X-Access-Token": this.uploadParam.accessToken}
    },
    methods: {
      beforeUpload: function (file) {
        let fileType = file.type;
        if (fileType.indexOf('image') < 0) {
          this.$message.warning('请上传图片');
          return false;
        }
      },
      handleChange(file, fileList) {
        if (file) {
          let Url = file.url;
          this.urlList.push(Url);
          this.imageUrl = Url;
        } else {
          this.$message.warning('图片上传失败！');
        }
      },
      pictureSure() {
        this.visible = false;
        let path = this.imageUrl;
        this.$emit('setComponentData', JSON.stringify(
          Object.assign({path: path})), this.conKey, this.componentFlag);
      },
      edit(conKey, componentFlag) {
        this.visible = true;
        this.conKey = conKey;
        this.componentFlag = componentFlag;
      },
      close() {
        this.visible = false;
      },
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/lib/editMoudle/eleSingleImageSimple.vue